import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { UseQueryResult } from '@tanstack/react-query'
import { isUndefined } from 'lodash'
import { getSmartMeterGatewayInfo, SmartMeterGatewayDto } from 'src/Libs/flow/installation/api/smart-meter-gateway'
import { usePortalQuery } from 'src/Libs/api'

export const useFetchSmartMeterGateway = (
  installationId: number | undefined,
  emcId: string | null,
  enabled = true
): UseQueryResult<SmartMeterGatewayDto, Error> => {
  const authFetch = useAuthFetchWithResponse()

  return usePortalQuery({
    queryKey: smartMeterGatewayQueryKey(installationId, emcId),
    queryFn: () => getSmartMeterGatewayInfo(installationId!, emcId ?? undefined, authFetch).then(res => res.value),
    enabled: !isUndefined(installationId) && !!emcId && enabled,
  })
}

export const smartMeterGatewayQueryKey = (installationId: number | undefined, emcId: string | null) =>
  ['installation', installationId, 'device-links', emcId, 'smart-meter-gateway'] as const
